module.exports = __webpack_public_path__ + "static/footer-bg-94834220ad7e983597a16741afbfbdca.png";